import React from 'react'
import { withRouter } from "react-router"
import { Formik, Form, Field, ErrorMessage } from 'formik'
import FieldWrapper from '../forms/FieldWrapper'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import WrapperAccordion from '../general/WrapperAccordion';
import RadioButtonGroup from './fields/RadioButtonGroup'
import RadioButtonMovieItem from './fields/SingleSelectRadioButtonMovieItem'
import * as Yup from 'yup';
import { sanitizeFormOutput, sanitizeFormInput } from '../../functions/formFunctions'
import MultiselectCheckboxCinemas from './fields/MultiselectCheckboxCinemas'
import Translation from '../Translation/cont/Translation'
import ListItemMovieContainer from '../DragAndDropItems/cont/ListItemMovieContainer'
import { MOVIE } from '../../constants/itemTypes'




const FormHighlightData = ({contentData, history, closePagePath, suffixEdit='', onUpdateHighlight, movieData, sortedMovieDataKeys, cliCinemas, cliCinemasIdList, features, clientCinemaId}) => {
    const validationSchema = Yup.object().shape({
        title: Yup.string()
            .required(<Translation id="formik_field_required">Dieses Feld wird benötigt!</Translation>),
        movieRefID: Yup.string()
            .required(<Translation id="formik_movie_required">Es muss ein Film ausgewählt werden!</Translation>),
    });
    
    return (
        <Formik
        initialValues={sanitizeFormInput(contentData, cliCinemas)}
        movieData={movieData}
        validationSchema={validationSchema}
        sortedMovieDataKeys={sortedMovieDataKeys}
        onSubmit={(values, actions) => {
            onUpdateHighlight(sanitizeFormOutput(values))
            actions.setSubmitting(false)
        }}
        onReset={(values, actions) => {
            history.push(closePagePath)
        }}>
        {({ values, errors, status, touched, isSubmitting, handleReset }) => (
                <Form>
                    <WrapperAccordion
                        className="single-section"
                        selectionActiveClass="accordion-item-open"
                    >
                        <fieldset>
                            <div className="form-content highlight">
                                <div className="left-sections">
                                    <FieldWrapper label={<Translation id="highlight_title" after="*">Überschrift</Translation>} id="content-title" classes="field-text">
                                        <Field type="text" name="title" id="content-title" className="text-regular input-text-box" />
                                        <ErrorMessage className="text-regular-color" name="title" component="div" /> 
                                    </FieldWrapper>

                                    <FieldWrapper label={<Translation id="highlight_text">Optionaler Text</Translation>} info={<Translation id="highlight_text_info"/>} id="content-text" classes="field-textarea field-textarea-text">
                                        <Field type="text" name="text" component="textarea" wrap="hard" maxLength="220" id="content-text" className="text-regular input-text-box" />
                                        <ErrorMessage className="text-regular-color" name="text" component="div" /> 
                                    </FieldWrapper>
                                    {_.has(values, "cinema") && cliCinemas ? (
                                        cliCinemasIdList.length > 1 ? (
                                            <fieldset className="field-cinemas">
                                                <legend className="field-text-label"><Translation id="cinemas">Kinos</Translation></legend>

                                                <div className="select-all-cinemas-button-wrapper">  
                                                    <div key={'field-all'} className="field-checkbox">
                                                        <Field 
                                                            key={'all'} 
                                                            attrid={'all'}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={'alle anwählen'}
                                                            clicinemas={'all'}
                                                            value={cliCinemasIdList} 
                                                            />
                                                    </div>
                                                </div>

                                                <div className="grid-container">
                                                    {cliCinemasIdList.map(cinemaId => {
                                                        const cinema = cliCinemas[cinemaId]
                                                        const {pk, nameShort} = cinema
                                                        
                                                        return (
                                                            <div key={'field' + pk} className="field-checkbox">
                                                                <Field 
                                                                    key={pk} 
                                                                    attrid={pk}
                                                                    name="cinemas"
                                                                    component={MultiselectCheckboxCinemas} 
                                                                    id={nameShort}
                                                                    clicinemas={cliCinemas}
                                                                    value={pk} 
                                                                    />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </fieldset>
                                        ) : (
                                            cliCinemasIdList.map(cinemaId => {
                                                const cinema = cliCinemas[cinemaId]
                                                const {pk, nameShort} = cinema
                                                
                                                return (
                                                    <div key={'field' + pk} className="field-checkbox">
                                                        <Field 
                                                            key={pk} 
                                                            attrid={pk}
                                                            name="cinemas"
                                                            component={MultiselectCheckboxCinemas} 
                                                            id={nameShort}
                                                            clicinemas={cliCinemas}
                                                            value={pk} 
                                                            />
                                                    </div>
                                                )
                                            })
                                        )
                                    ) : (
                                        ''
                                    )}
                                    {features && features.has_mcs_app && <div className="field-checkbox field-text">
                                        <label>
                                            <p className="field-text"><Translation id="app_settings">App Einstellungen</Translation></p>
                                            <Field type="checkbox" name="showInApp" id="show-in-app" className="checkbox"/>
                                            <span className="show-in-app-text text-regular"><Translation id="app_display">in der App anzeigen</Translation></span>
                                        </label>
                                        <ErrorMessage className="text-regular-color" name="showInApp" component="div" />
                                    </div>}
                                </div>
                                <div className="right-sections">
                                    {sortedMovieDataKeys && !_.isEmpty(movieData) && sortedMovieDataKeys.length > 0 ? (
                                        <RadioButtonGroup
                                        label={<Translation id="highlight_movie_link" after="*">Filmverknüpfung</Translation>}
                                        className="select-new-section-type"
                                        >
                                        <ErrorMessage className="text-regular-color movie-error" name="movieRefID" component="div" /> 

                                            {sortedMovieDataKeys.map((movieID) => {
                                                const movie = movieData[movieID]
                                                const intId = movie.id
                                                const {cinemaIds, title} = movie
                                                const cliCinemas = values.cinemasFilter
                                                const cinemasIntersectionArray = _.intersection(cinemaIds, cliCinemas)
                                                const pathnameEdit = `${closePagePath}/${MOVIE}/${intId}${suffixEdit}`
                                                
                                                if(cinemasIntersectionArray.length !== 0 && cinemasIntersectionArray.length === cliCinemas.length) {                                                
                                                    return (
                                                        <Field
                                                            key={intId}
                                                            component={RadioButtonMovieItem}
                                                            name="movieRefID"
                                                            id={intId}
                                                            movie={movie}
                                                            label={title}
                                                            pathnameEdit={pathnameEdit}
                                                        />
                                                    )
                                                } else {
                                                    return (
                                                        <div key={intId} className="movie-item-radio-wrapper">
                                                            <ListItemMovieContainer
                                                                itemType={MOVIE}
                                                                itemData={movie}
                                                                additionalClass='no-selection-possible'
                                                                pathnameEdit={pathnameEdit}
                                                            />
                                                        </div>
                                                    )
                                                }
                                            })}
                                        </RadioButtonGroup>
                                    ) : (
                                        <p>Keine Filme verfügbar.</p>
                                    )}
                                </div>
                            </div>
        
                            <ButtonSubmitCancel
                                transIdCancel="cancel_button"
                                transIdSubmit="save_highlight_button"
                                disabledCancel={isSubmitting}
                                disabledSubmit={isSubmitting}
                                onCancel={handleReset}
                            />
                        </fieldset>
                    </WrapperAccordion>
                </Form>
            )}

        </Formik>
    )
}


export default withRouter(FormHighlightData) 